<template>
  <div id="app">
    <div
      v-if="
        $route.path !== '/login' &&
        $route.path !== '/account/reset' &&
        $route.path !== '/maintenance'
      "
    >
      <AppNav />
    </div>
    <div id="view">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>
<script>
import AppNav from './components/Nav.vue';

export default {
  name: 'App',
  components: {
    AppNav,
  },
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#view {
  margin-left: 30px;
  margin-top: 20px;
  align-content: left;
}
nav {
  margin-top: 25px;
  margin-bottom: 30px;
}

th {
  width: fit-content;
  min-width: 0px;
}
</style>
